define([
  'immutable',
  'es6!sumo/util',
  'es6!launcher/actions/SubscribersActions',
], (Immutable, Util, Actions) => {
  const { cacheGet, cacheSet, cacheGetSiteNs } = Util;

  const getCachedState = () => {
    const cacheKey = `${cacheGetSiteNs()}:subscribers:state`;
    const cachedState = cacheGet(cacheKey);

    if (cachedState) {
      cachedState.list = Immutable.fromJS(cachedState.list);

      return cachedState;
    }

    return {};
  };

  const cacheState = (state) => {
    const {
      list,
      total,
    } = state.toJS();
    const cacheKey = `${cacheGetSiteNs()}:subscribers:state`;

    // drop down to json so we can serialize
    return cacheSet(cacheKey, {
      list,
      total,
    });
  };

  const cachedState = getCachedState();
  const initialState = Immutable.Map({
    list: Immutable.List(),
    errors: Immutable.Map(),
    error: null,
    loading: false,
    fetchedAt: null,
    total: 0,
    page: 1,
    perPage: 10,
    filter: 'email',
    subfilter: 'contains',
    filterText: '',
    selectAllSubscribers: false,
    toggledSubscribers: {},
    download: Immutable.Map(),
    imports: Immutable.Map(),
    activeImport: '',
    isOverSubscriberLimit: false,
    overSubscriberLimitBy: 0,
    lastSortVal: null,
    subscriber: Immutable.Map(),
    subscriberFeed: Immutable.Map(),
    ...cachedState,
  });

  const actionHandlers = {};

  actionHandlers[Actions.INVALIDATE_SUBSCRIBERS_CACHE] = state => state.set('fetchedAt', null);

  actionHandlers[Actions.REQUEST_SUBSCRIBERS] = state => state.set('loading', true);

  actionHandlers[Actions.REQUEST_SUBSCRIBER] = state => (
    state.merge({
      loading: true,
      error: null,
      subscriber: Immutable.Map(),
    })
  );

  actionHandlers[Actions.RECEIVE_SUBSCRIBERS] = (state, action) => {
    const pagination = Immutable.fromJS(action.subscribers.pagination);
    const totalEmail = Immutable.fromJS(action.subscribers.totalEmail);
    const totalPush = Immutable.fromJS(action.subscribers.totalPush);
    let nextState = state;

    nextState = state.merge({
      loading: false,
      list: Immutable.fromJS(action.subscribers.subscribers),
      fetchedAt: Date.now(),
      total: pagination.get('total'),
      page: pagination.get('page'),
      perPage: pagination.get('perPage'),
      totalEmail,
      totalPush,
      errors: Immutable.Map(),
      isOverSubscriberLimit: action.subscribers.isOverSubscriberLimit,
      overSubscriberLimitBy: action.subscribers.overSubscriberLimitBy,
      lastSortVal: action.subscribers.lastSortVal,
    });

    // cache for next load
    cacheState(nextState);

    return nextState;
  };

  actionHandlers[Actions.RECEIVE_SUBSCRIBER] = (state, action) => (
    state.merge({
      loading: false,
      subscriber: Immutable.fromJS(action.data.subscriber),
      errors: Immutable.Map(),
    })
  );

  actionHandlers[Actions.DELETE_SUBSCRIBERS] = (state, action) => {
    let newList = state.get('list');
    let newTotal = state.get('total');

    if (action.selectAllSubscribers) {
      newList = Immutable.fromJS([]);
      newTotal = 0;
    } else if (action.subscriberIds) {
      newList = newList.filter(subscriber => (
        action.subscriberIds.indexOf(subscriber.get('id')) === -1
      ));
      newTotal = newTotal - action.subscriberIds.length;
    }

    return state.merge({
      list: newList,
      total: newTotal,
    });
  };

  actionHandlers[Actions.RECEIVE_DOWNLOAD_PROGRESS] = (state, action) => (
    state.setIn(['download'], Immutable.fromJS(action.status))
  );

  actionHandlers[Actions.ERROR_SUBSCRIBERS] = (state, action) => {
    const code = action.code;
    const error = action.error;

    const retState = state.set('loading', false);

    return retState.mergeIn(['errors'], { [code]: `${error}` });
  };

  actionHandlers[Actions.ERROR_SUBSCRIBER] = (state, action) => (
    state.merge(Immutable.fromJS({
      loading: false,
      error: action.data,
    }))
  );

  actionHandlers[Actions.UPDATE_SUBSCRIBERS_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (!settingName || !settingValue) return state;
    return state.setIn([settingName], Immutable.fromJS(settingValue));
  };

  actionHandlers[Actions.UPDATE_SUBSCRIBERS_FILTER] = (state, action) => {
    const filters = action.filter;
    let retState = state;

    Object.keys(filters).forEach((filter) => {
      retState = retState.set(filter, filters[filter]);
    });

    return retState;
  };

  actionHandlers[Actions.REQUEST_SHOPIFY_SYNC] = state => state.set('loading', true);
  actionHandlers[Actions.RECEIVE_SHOPIFY_SYNC] = state => state.set('loading', false);


  return Util.createReducer(initialState, actionHandlers);
});
